import { render, staticRenderFns } from "./account-info.vue?vue&type=template&id=1c6f2035&scoped=true&"
import script from "./account-info.vue?vue&type=script&lang=ts&"
export * from "./account-info.vue?vue&type=script&lang=ts&"
import style0 from "./account-info.vue?vue&type=style&index=0&id=1c6f2035&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6f2035",
  null
  
)

export default component.exports